module.exports = __webpack_public_path__ + "img/6S.90a64610.png";